import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function TechniquesSection() {
  const items = ['Secretos para dominar el e-book de técnicas orales', 'Lectura rápida y práctica - resultados inmediatos', '15 posiciones bonus incluidas', '3 guías extras GRATIS'];
  return <section className="py-24 bg-gradient-to-br from-[#1A0230] via-[#2A044A] to-[#0D0118] relative px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-152">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-153">
        <div className="absolute top-[20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-[#FF2D8A]/10 blur-[100px]" data-id="element-154" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-[#9D00FF]/10 blur-[100px]" data-id="element-155" />
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-156">
        {/* Product Mockup Side */}
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative order-2 lg:order-1 flex items-center justify-center" data-id="element-157">
          <motion.div animate={{
          y: [0, -12, 0]
        }} transition={{
          repeat: Infinity,
          duration: 5,
          ease: 'easeInOut'
        }} className="relative" data-id="element-158">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-[#FF2D8A]/15 blur-[50px] rounded-full scale-75 pointer-events-none" data-id="element-159" />
            <div className="absolute inset-0 bg-[#9D00FF]/10 blur-[70px] rounded-full scale-90 pointer-events-none" data-id="element-160" />

            <img src="https://cdn.magicpatterns.com/uploads/bwiWJshp8JHJYiMJzY6Hxy/freepik__woman-smiling-with-confident-seductive-energy-rela__46400.png" alt="Expertas en BallCat - Mockup del Producto" className="relative z-10 w-full max-w-xs sm:max-w-sm lg:max-w-md rounded-2xl shadow-[0_0_40px_rgba(255,45,138,0.3)]" data-id="element-161" />

            {/* Badge overlay */}
            <div className="absolute -bottom-4 -right-4 z-20 bg-gradient-to-r from-[#FF2D8A] to-[#9D00FF] text-white font-black text-lg px-5 py-3 rounded-xl shadow-[0_0_20px_rgba(255,45,138,0.5)] transform rotate-3" data-id="element-162">
              29 TÉCNICAS
            </div>
          </motion.div>
        </motion.div>

        {/* Text Content Side */}
        <motion.div initial={{
        opacity: 0,
        x: 40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="order-1 lg:order-2" data-id="element-163">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white mb-6 leading-tight" data-id="element-164">
            TÉCNICAS QUE VAN A{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF2D8A] to-[#FFD700]" data-id="element-165">
              ENLOQUECER A CUALQUIERA
            </span>{' '}
            CON TU BOCA
          </h2>

          <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-166">
            Descubrí las 29 técnicas exactas que transforman un momento común en
            una experiencia inolvidable. Aprenderás a usar tus labios, lengua y
            respiración para crear sensaciones eléctricas que lo dejarán sin
            palabras.
          </p>

          <ul className="space-y-4 mb-10" data-id="element-167">
            {items.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1 + 0.3
          }} className="flex items-center gap-4 bg-white/5 p-4 rounded-xl border border-white/5 backdrop-blur-sm" data-id="element-168">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#22C55E] to-[#16A34A] flex items-center justify-center shrink-0 shadow-[0_0_10px_rgba(34,197,94,0.4)]" data-id="element-169">
                  <CheckIcon className="w-5 h-5 text-white" strokeWidth={3} data-id="element-170" />
                </div>
                <span className="text-lg text-white font-medium" data-id="element-171">{item}</span>
              </motion.li>)}
          </ul>

          <div className="bg-[#0D0118]/80 p-6 rounded-2xl border border-[#FF2D8A]/30 text-center" data-id="element-172">
            <p className="text-gray-400 font-medium mb-2 uppercase tracking-wider text-sm" data-id="element-173">
              Oferta especial por tiempo limitado
            </p>
            <p className="text-3xl font-black text-white" data-id="element-174">
              TODO ESTO POR SOLO{' '}
              <span className="text-[#FFD700]" data-id="element-175">$14.999 ARS</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}